import React from 'react';

// Champ du panneau de droite avec son libellé empilé au-dessus. Pour les
// contrôles larges (sélecteurs de titres, listes) qui ne laissent pas la place
// à un libellé posé à leur gauche dans une colonne de 250px — cf. LabelledRow
// pour les contrôles étroits.
const labelStyle = {
  fontSize: 12,
  fontWeight: 500,
  color: 'rgba(11, 34, 57, 0.65)',
};

const StackedLabelField = ({ label, children }) => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: 4, width: '100%' }}>
    <span style={labelStyle}>{label}</span>
    {children}
  </div>
);

export default StackedLabelField;
